/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientAdminModel } from '../../models/patient-admin-model';

export interface AdminPersonIdGet$Params {
  personId: string;
  summary?: boolean;
}

export function adminPersonIdGet(http: HttpClient, rootUrl: string, params: AdminPersonIdGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<PatientAdminModel>> {
  const rb = new RequestBuilder(rootUrl, adminPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
    rb.query('summary', params.summary, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<PatientAdminModel>;
    })
  );
}

adminPersonIdGet.PATH = '/Admin/{personId}';
